/* eslint-disable */

import { rootApi } from '../rootApi';

export const warrantyPeriodApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getWarrantyPeriodAll: builder.query({
            query: ({ pageNumber, pageSize, carItemCode ,productGroup,startDate,endDate}) => {
                const queryParams = {
                    PageNumber: pageNumber !== undefined ? pageNumber : 0,
                    PageSize: pageSize || 10
                };
                if (carItemCode) {
                    queryParams.CarItemCode = carItemCode;
                }
                if (productGroup) {
                    queryParams.productGroup = productGroup;
                }
                if (startDate) {
                    queryParams.startDate = startDate;
                }
                if (endDate) {
                    queryParams.endDate = endDate;
                }

                return {
                    url: 'v1/vehiclewarrantyperiod',
                    method: 'GET',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.items)) {
                        return response.data;
                    }
                    if (Array.isArray(response.items)) {
                        return response;
                    }
                }
                return { items: [], totalCount: 0 };
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: ['WarrantyPeriod']
        }),

        GetWarrantyPeriodById: builder.query({
            query: (id) => {
                return `v1/vehiclewarrantyperiod/${id}`;
            },
            transformResponse: (response) => {
                return response?.data || null;
            },
            providesTags: (result, error, id) => [{ type: 'WarrantyPeriod', id }]
        }),

        createWarrantyPeriodAsync: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/vehiclewarrantyperiod',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: ['WarrantyPeriod']
        }),

        UpdateWarrantyPeriod: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/vehiclewarrantyperiod',
                    method: 'PATCH',
                    body: data
                };
            },
            invalidatesTags: (result, error, { id }) => [{ type: 'WarrantyPeriod', id }]
        }),

        DeleteWarrantyPeriod: builder.mutation({
            query: (id) => {
                return {
                    url: `v1/vehiclewarrantyperiod`,
                    method: 'DELETE',
                    body: { id }
                };
            },
            invalidatesTags: ['WarrantyPeriod']
        }),

        getProductGroupsDropdownList: builder.query({
            query: () => {
                return { url: 'v1/exportedcars/productgroups' };
            },
            transformResponse: (response) => {
                return Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: ['ExportedCars']
        }),

        getVehicleItemsDropdownList: builder.query({
            query: (params) => {
                const queryParams = {
                    ProductGroup: params?.ProductGroup || ''
                };
                return {
                    url: 'v1/exportedcars/vehicleitems',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                return Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: ['ExportedCars']
        })
    })
});

export const {
    useGetWarrantyPeriodAllQuery,
    useGetWarrantyPeriodByIdQuery,
    useCreateWarrantyPeriodAsyncMutation,
    useUpdateWarrantyPeriodMutation,
    useDeleteWarrantyPeriodMutation,
    useGetProductGroupsDropdownListQuery,
    useGetVehicleItemsDropdownListQuery
} = warrantyPeriodApi;
